import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_CAUHINHGOITRAGOP } from "../../../actions/CauHinhGoiTraGop/actionTypes";
import {
  getListCauHinhGoiTraGopSuccess,
  getListCauHinhGoiTraGopFailure,
} from "../../../actions/CauHinhGoiTraGop";
import BanHangTraGopApi from "service/banHangTraGopApi";

function* getListCauHinhGoiTraGop(action) {
  try {
    const response = yield call(
      BanHangTraGopApi.listCauHinhGoiTraGop,
      action.dataSearch
    );
    console.log(response, "danh sách gói trả góp sagas");
    if (response.ok) {
      yield put(getListCauHinhGoiTraGopSuccess(response.data));
    } else {
      yield put(getListCauHinhGoiTraGopFailure());
    }
  } catch (error) {
    yield put(getListCauHinhGoiTraGopFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_CAUHINHGOITRAGOP, getListCauHinhGoiTraGop);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
